import React from "react";

export function Card({ hover = false, className = "", children, ...props }) {
  return (
    <div
      className={`bg-surface-container rounded-[10px] border border-outline-variant shadow-card overflow-hidden ${hover ? "hover:border-primary/40 transition-colors duration-150 group" : ""} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function GlassCard({ elevated = false, hover = false, className = "", children, ...props }) {
  return (
    <div
      className={`${elevated ? "glass-card-elevated" : "glass-card"} relative overflow-hidden ${hover ? "hover:border-primary/40 transition-colors duration-150 cursor-pointer group" : ""} ${className}`}
      {...props}
    >
      <div className="relative z-10">{children}</div>
    </div>
  );
}
